import { useSortable } from "@dnd-kit/sortable";
import React from "react";
import { CSS } from "@dnd-kit/utilities";
import { Grid, IconButton } from "@mui/material";
import { DragIndicator } from "@mui/icons-material";
import JobStatus from "../../../types/jobStatus";

interface Props {
  children: React.ReactNode;
  status: JobStatus;
}

const StatusSortableItem: React.FC<Props> = (props) => {
  const { children, status } = props;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    setActivatorNodeRef,
  } = useSortable({
    id: status.order!,
    data: status,
    animateLayoutChanges: () => false,
  });
  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Translate.toString(transform),
        transition: transition,
        paddingBottom: 25,
        width: "100%",
      }}
    >
      <Grid container>
        <IconButton {...attributes} {...listeners} ref={setActivatorNodeRef}>
          <DragIndicator />
        </IconButton>
        {children}
      </Grid>
    </div>
  );
};

export default StatusSortableItem;
